export default {
    name: "SonAboutUs",
    created() {
        this.$nextTick(function () {
 
        });
    },
    mounted() {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {

    },
    methods: {

    }
};